import { forwardRef } from 'react';

import { cx } from '../../utils/cx';
import { Stack, type StackProps } from '../stack/stack';

import styles from './empty_state.module.css';

export type EmptyStateContainerProps = StackProps;

/**
 * EmptyStateContainer - container for empty state content.
 *
 * Composes optional child sub-components such as `EmptyStateIcon` or
 * `EmptyStateImage`, `EmptyStateHeading`, `EmptyStateText`, and `EmptyStateActionButton`.
 *
 * ```tsx
 * <EmptyStateContainer>
 *   <EmptyStateIcon name="storage_on_premise" size="l" />
 *   <EmptyStateHeading>No storages yet</EmptyStateHeading>
 *   <EmptyStateText>Create a storage to get started.</EmptyStateText>
 *   <EmptyStateActionButton>Create storage</EmptyStateActionButton>
 * </EmptyStateContainer>
 * ```
 */
export const EmptyStateContainer = forwardRef<
  HTMLDivElement,
  EmptyStateContainerProps
>(({ className, children, ...rest }, ref) => {
  return (
    <Stack
      ref={ref}
      alignItems="center"
      justifyContent="center"
      className={cx([styles.empty_state, className])}
      gap="none"
      {...rest}
    >
      {children}
    </Stack>
  );
});
